import type { TranslationGroup } from '../../../common/locales/types/translationTypes';

/**
 * Shared helper to register translations for debug highlighting
 */
export function registerTranslationForDebug(translatedText: string, group: TranslationGroup, fullKey: string): void {
    if (typeof window === 'undefined' || !document.body.classList.contains('translation-debug-highlight')) {
        return;
    }

    if (!window.__hookTranslationDebugRegistry) {
        window.__hookTranslationDebugRegistry = new Map();
    }

    window.__hookTranslationDebugRegistry.set(translatedText, {
        group,
        key: fullKey,
        timestamp: Date.now(),
    });
}
